import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ApiService } from '../services/api.service';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class CallLogsGuard implements CanActivate {

  constructor(
    private apiService: ApiService,
    private router: Router,
    private authService: AuthService
  ) {}

  async canActivate(): Promise<boolean> {
    try {
      // Permitir acceso inmediato a correos autorizados (evita carreras al cargar auth)
      const user = await this.authService.getUserData();
      const ALLOWED = ['jorge@meetzy.io', 'lorenzo@meetzy.io'];
      if (user?.email && ALLOWED.includes(user.email)) {
        return true;
      }

      // En otros casos, verificar contra el backend
      const hasAccess = await this.apiService.hasCallLogsAccess();
      
      if (!hasAccess) {
        console.log('🚫 CallLogsGuard: Acceso denegado a Call Logs');
        // Redirigir a una página de acceso denegado o home
        this.router.navigate(['/']);
        return false;
      }
      
      console.log('✅ CallLogsGuard: Acceso autorizado a Call Logs');
      return true;
      
    } catch (error) {
      console.error('❌ CallLogsGuard: Error verificando acceso (permitiendo paso para que componente valide):', error);
      // Permitir navegación y dejar que el componente haga la verificación y redirección
      return true;
    }
  }
}
